// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"552581":"lazy-survey","706569":"lazy-jury"}[chunkId] + "." + {"552581":"d7d9d39a","706569":"be0a93bf"}[chunkId] + ".chunk.css";
};